import { http_client } from '@/plugins/http_client';

const obtenerRamos = async params => await http_client('api/v1/ramos', params);
const obtenerRamosSinPagina = async () => await http_client('api/v1/catalogo/ramos');
const crearRamo = async body => await http_client('api/v1/ramos', body, 'post');
const actualizarRamo = async (id, body) =>
  http_client(`/api/v1/ramos/${id}`, body, 'patch');
const cambiarEstadoRamo = async (id, body) =>
  http_client(`/api/v1/ramos/${id}`, body, 'put');

export default {
  crearRamo,
  obtenerRamos,
  actualizarRamo,
  cambiarEstadoRamo,
  obtenerRamosSinPagina,
};
